import firebase from 'firebase/app';
import 'firebase/messaging';
import 'utils/core/configInit'; // make sure to initialize config before using it
import { getEnvironmentConfig } from 'companion-app-components/utils/core';

let fbMessaging = null;

/////////////////////////////////////
///////////////////
////////////////////////////////////////////////
//////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////
//

//////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
/////////

export const messaging = fbMessaging;
